import * as React from 'react';
import {ChangeEvent} from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


export interface BranchData{
    id: number;
    name: string;
    referenceId?: string;
    location: {
        lat: number;
        lng: number ;
        street1: string;
        street2?: string;
        number?: string;
    }
    observation?: string;
    company: {
      id: number,
      name: string,
      photo: string,
      admin:string
    }
    maxDistanceValidation?: boolean;
    maxDistance?: number;
    inicioVentana?: string;
    finVentana?: string;

}


interface BranchSelectorState {
    branchList: BranchData[];
    selectedIndex: number;
}


export interface BranchSelectorProps {
    value?: number;
    branchList: BranchData[]|undefined;
    onChange : (e:ChangeEvent<HTMLSelectElement>) => any ;
    
}


export class BranchSelector extends React.Component< BranchSelectorProps, BranchSelectorState> {
    private estaMontado: boolean = false;

    constructor(props: BranchSelectorProps) {
        super(props);
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        let selectedIndex = 0;
        if (props.branchList) {
            const idx = props.branchList.findIndex((branch) => branch.id === props.value);
            selectedIndex = idx !== -1 ? idx : 0;
        }
        this.state = {
            selectedIndex,
            branchList: []
        };
    }

    componentDidMount() {
        this.estaMontado = true;
    }

    componentWillUnmount() {
        this.estaMontado = false;
    }
 
    handleChangeEvent(e:ChangeEvent<HTMLSelectElement>){
        this.props.onChange(e);
        if (this.estaMontado) {
            this.setState({
                selectedIndex: +e.target.value
            });
        }
    }

    render(){
        return (
            // this.state.selectedIndex && 
        <Select
            value={this.state.selectedIndex}
            inputProps={{
            name: 'branch-selector',
            id: 'branchSelector',
            }}   
            onChange={this.handleChangeEvent}
        >
            {this.props.branchList? this.props.branchList.map((branch, index) => 
                <MenuItem key={index} value={index}>  
                {branch.company.name} / {branch.name} </MenuItem>):''} 
        
        </Select>);
    }


}


export default BranchSelector;


// WEBPACK FOOTER //
// ./src/components/BranchSelector.tsx